export const RacingMarketTypes = {
	WINNER: 1,
	FORECAST: 2,
	TRICAST: 3,
};
